/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ReviewSummaryView.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

const ContactInformationSummary = ({ t, i18n, setIsError, reviewConfirmation = false }) => {
    let history = useHistory()

    const { email, phoneNumber, name } = useSelector((state) => state.app.contactInformation)
    useEffect(() => {
        try {
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }, [email, phoneNumber, setIsError])

    const editContactInfoOnClick = () => {
        try {
            history.push(`/${i18n.language}${t('routes.contact_info')}?isSummary=true`)
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    // const dashIfNull = (data) => {
    //     return data ? data : '-'
    // }

    return (

        <div className="row">
            <div className="col-xs-12 col-lg-8">
                <div className="col-xs-12">
                    <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
                        <div style={{ display: "flex", flexGrow: 1, justifyContent: "space-between", alignItems: "center" }}>
                            <div className="col-xs-6">
                                <h3>{t('review_summary.contact_info')}</h3>
                                <br></br>

                            </div>
                            <div className="col-xs-6">

                                <a href="#" className={[styles['edit_button']].join(' ')}
                                    onClick={editContactInfoOnClick}
                                    value={t('review_summary.edit')} name={t('review_summary.edit')}>
                                    {t('review_summary.edit')}
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                        <div className="col-xs-6"><strong>{name ? t('contact_info.name') : t('review_summary.phone_number')}</strong></div>
                        <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{name ? name : phoneNumber}</div>
                    </div>
                    <hr />

                    {name &&
                        (
                            <>
                                <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                                    <div className="col-xs-6"><strong>{t('review_summary.phone_number')}</strong></div>
                                    <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{phoneNumber}</div>
                                </div>
                                <hr />
                            </>
                        )
                    }

                    {/* <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                        <div className="col-xs-6"><strong>{t('review_summary.phone_number')}</strong></div>
                        <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{phoneNumber}</div>
                    </div>
                    <hr /> */}


                    <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                        <div className="col-xs-6"><strong>{t('review_summary.email')}</strong></div>
                        <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{email}</div>
                    </div>

                    <hr />

                </div>
            </div>
        </div>

        //division
        // <div className="row">
        //     <div className="col-xs-12 col-lg-8" >
        //         <div className="col-xs-12" style={{ border: '1px solid black' }}>
        //             <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
        //                 <div style={{ flexGrow: 1 }}>
        //                     <div className="col">
        //                         <h2>{t('review_summary.contact_info')}</h2>
        //                     </div>
        //                 </div>
        //             </div >

        //             <div className="row" style={{ display: 'flex', flexGrow: 1, backgroundColor: "lightgray" }}>
        //                 <div className="col"><strong>{name ? t('contact_info.name') : t('review_summary.phone_number')}</strong></div>
        //                 <div className="col">{name ? name : phoneNumber}</div>

        //                 <div className="col" style={{
        //                     display: "flex", justifyContent: "flex-end", alignItems: "center"
        //                 }} >
        //                     <a
        //                         href="#"
        //                         className={[styles['edit_button']].join(' ')}
        //                         onClick={editContactInfoOnClick}
        //                         value={t('review_summary.edit')}
        //                         name={t('review_summary.edit')}
        //                     >
        //                         {t('review_summary.edit')}
        //                     </a>
        //                 </div>
        //             </div>
        //             {name &&
        //                 (
        //                     <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
        //                         <div className="col" ><strong>{t('review_summary.phone_number')}</strong></div>
        //                         <div className="col">{phoneNumber}</div>
        //                         <div className="col" />
        //                     </div>
        //                 )
        //             }
        //             <div className="row" style={{ display: 'flex', flexGrow: 1, backgroundColor: name ? "lightgray" : "" }}>
        //                 <div className="col" ><strong>{t('review_summary.email')}</strong></div>
        //                 <div className="col" style={{ lineBreak: "anywhere" }}>{email}</div>
        //                 <div className="col" />
        //             </div>

        //         </div>
        //     </div>
        // </div>
    )
}


export default withTranslation('common')(ContactInformationSummary)
